<template>
    <div>
        <modal-cadu
            :close="close"
            :width="800"
            v-model="show"
        >
            <div slot="all" class="pt-10 pb-4 px-10">
                <div slot="header">
                    <div class="font-primaria headline font-weight-bold pb-4" style="color: #00995D">
                        Importar arquivo
                    </div>
                </div>
                <div slot="body">
                    <v-row>
                        <v-col cols="6">
                            <validation-provider name="tipoTabela" ref="tipoTabela" mode="eager" rules="required" v-slot="{ errors }">
                                <autocomplete-cadu
                                    :errorMessage="errors[0]"
                                    :items="listaTabelas.map((el) => el.nome)"
                                    title="Tabela"
                                    v-model="tipoTabela.nome"
                                    @index="indexDominios"
                                />
                            </validation-provider>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <div class="drag-doc-area">
                                <input
                                    type="file"
                                    @input="filesChange($event)"
                                    accept=".xlsx"
                                    class="input-file"
                                    :value="fileInput"
                                >
                                <v-row no-gutters align="center" justify="center">
                                    <v-col cols="6" class="drag-text-icon my-12">
                                        <v-row no-gutters justify="center" align="center">
                                            <v-col cols="3" class="icon">
                                                <icon name="paperclip" :size="40" style="cursor: pointer" class="mx-6 my-5" tooltip="Importar"/>
                                            </v-col>
                                            <v-col cols="9" class="px-4 fontColor--text subtitle-2" v-if="file == ''">
                                                Arraste e solte seu arquivo aqui ou <span class="text">clique</span> para localizar
                                            </v-col>
                                            <v-col cols="9" class="px-4" v-else>
                                                <div>Nome do arquivo: {{dadosArquivo.nome}}</div>
                                                <div>Tamanho do arquivo: {{dadosArquivo.tamanho}} KB</div>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <p class="mx-4 my-2 fontColor--text subtitle-2">
                                    O arquivo deve ter no máximo 15 MB e estar no formato XLSX.
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                </div>
                <div slot="footer" class="pt-6">
                    <div v-if="!$vuetify.breakpoint.xs">
                    <v-row align="start" justify="start">
                        <v-col cols="auto">
                            <button-cadu
                                outline
                                @click="$emit('input', false)"
                            >
                                VOLTAR
                            </button-cadu>
                        </v-col>
                        <v-row align="end" justify="end" class="mr-2">
                            <v-col
                                @click="verifyCombo"
                                cols="auto"
                            >
                                <button-cadu>
                                    SALVAR
                                </button-cadu>
                            </v-col>
                        </v-row>
                    </v-row>
                    </div>
                    <div v-else>
                    <v-row>
                        <v-col
                            @click="verifyCombo"
                            cols="12"
                        >
                            <button-cadu block>
                                SALVAR
                            </button-cadu>
                        </v-col>
                        <v-col cols="12">
                            <button-cadu
                                block
                                outline
                                @click="$emit('input', false)"
                            >
                                VOLTAR
                            </button-cadu>
                        </v-col>
                    </v-row>
                    </div>
                </div>
            </div>
        </modal-cadu>
        <overlay-loading v-model="loadingImage" />
        <error-modal
          v-model="error"
          :errObj="errObj"
        />
    </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import TabelaDominios from '@/services/Dominios/TabelaDominios'

export default {
  components: {
    ValidationProvider
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    listaTabelas: {
      type: Array
    }
  },
  data () {
    return {
      show: this.value,
      tipoTabela: {
        nome: '',
        valor: ''
      },
      close: true,
      tipoDocumento: '',
      listaTipoDocumento: [],
      abaRelacionada: '',
      listaAbaRelacionada: [],
      fileInput: '',
      inputFile: undefined,
      formData: new FormData(),
      file: '',
      dadosArquivo: {
        nome: '',
        tipo: '',
        tamanho: ''
      },
      error: false,
      errObj: {},
      loadingImage: false,
      filePutComplete: false,
      tokenBearer: localStorage.getItem('tokenBearer')
    }
  },
  methods: {
    indexDominios (index) {
      this.tipoTabela.valor = (index > -1 && index !== null) ? this.listaTabelas[index].valor : ''
    },
    start (tipoTabela) {
      this.tipoTabela = tipoTabela
    },
    async verifyCombo () {
      const res = await this.$refs.tipoTabela.validate()

      if (res.valid) {
        this.loadingImage = true
        await this.importarDominio()
        this.loadingImage = false
      }
    },
    async importarDominio () {
      const tabelaDominios = new TabelaDominios(this.tokenBearer, this.$appConfig.config.API)

      try {
        this.formData.append('arquivo', this.inputFile)
        await tabelaDominios.putDominio(this.formData, this.tipoTabela.valor)
        this.$emit('success')
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        console.error(err)
      }
    },
    async filesChange (e) {
      this.fileInput = ''
      this.inputFile = undefined
      this.formData = new FormData()

      this.image = ''
      let files = e.target.files || e.dataTransfer.files
      this.inputFile = files[0]
      let file = files[0]

      this.dadosArquivo.nome = file.name
      this.dadosArquivo.tamanho = (file.size / 1024).toFixed(2)
      this.dadosArquivo.tipo = file.type
      this.createFile(files[0])
    },
    createFile (file) {
      var reader = new FileReader()
      var vm = this

      reader.onloadend = (e) => {
        vm.file = e.target.result
      }

      reader.readAsDataURL(file)
    },
    limparCampos () {
      if (!this.show) {
        this.file = ''
        this.tipoTabela = {}
      }
    }
  },
  watch: {
    value () {
      this.show = this.value
    },
    show () {
      this.$emit('input', this.show)
      this.limparCampos()
    }
  }
}
</script>

<style scoped>
    .drag-doc-area{
        border-radius: 22px;
        background-color: #dee2e6;
        width: 100%;
        height: 180px;
        position: relative;
    }

    .drag-text-icon{
        width: 100%;
        height: 80px;
    }

    .icon{
        width: 100%;
        height: 80px;
        border-radius: 22px;
        background-color: #FFF;
        color: #00995d;
    }

    .text{
        cursor: pointer;
        color: #00995d;
    }

    .input-file{
        opacity: 0;
        position: absolute;
        top: 0;
        height: 180px;
        width: 90%;
    }

    .input-file :hover{
        cursor: pointer
    }

</style>
